import { ApplicationMenuItemEntry } from '../../components/layout/dashboard/ApplicationMenu'
import { getAppPath } from '../../contracts/applications'

const applicationName = 'Strength Discovery'

const generateMenuItems = (specialistId: string): Array<ApplicationMenuItemEntry> => [
    {
        path: getAppPath('STRENGTH_DISCOVERY', specialistId),
        title: 'Strength Discovery',
    },
]

export { generateMenuItems, applicationName }
